/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum PageTypeEnum {
    CUSTOM_PAGE = 'CUSTOM_PAGE',
    HOME_PAGE_CONTENT = 'HOME_PAGE_CONTENT',
    ORCA_RESERVATION = 'ORCA_RESERVATION',
    INSTRUCTION_VIDEOS = 'INSTRUCTION_VIDEOS',
    RESERVATION_OVERVIEW = 'RESERVATION_OVERVIEW',
}